import { Deserializable } from '../protocols/deserializable';
import { PaylineCurrencyType } from '../../views/banking/models/payline-currency-type';

export class PaylineAccountSubmission implements Deserializable {
  public new!: PaylineAccountSubmissionData;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.new) {
      this.new = Deserialize.instanceOf(PaylineAccountSubmissionData, this.new);
    }
  }
}

export class PaylineAccountSubmissionData implements Deserializable {
  public currencyId!: number;
  public accountNumber!: string;
  public bankName!: string;
  public currency!: PaylineCurrencyType;

  public onDeserialize(): void {
    const Deserialize = window.injector.Deserialize;

    if (!!this.currency) {
      this.currency = Deserialize.instanceOf(PaylineCurrencyType, this.currency);
    }
  }
}
